import app from 'srcJs/App';
import { useEffect, useState } from 'react';
import UserType from 'moduleBase/types/user/UserType';

const useUserData = () => {
  const user = app.getUser();
  const [userData, setUserData] = useState<UserType>(user.getData());

  useEffect(() => {
    const subscription = user.onChange((userDataNew) => {
      setUserData(userDataNew);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return userData;
};

export { useUserData };
